<template>
    <v-dialog
        v-model="dialog"
        max-width="840px">
        <template
            v-for="(_, slot) of $scopedSlots"
            v-slot:[slot]="scope">
            <slot
                :name="slot"
                v-bind="scope"/>
        </template>

        <v-card>
            <v-card-actions>
                <div class="title font-weight-bold">{{ $t('ibeacon.map') }}</div>
                <v-spacer/>
                <v-btn
                    icon
                    @click="close">
                    <icon
                        value="close"/>
                </v-btn>
            </v-card-actions>

            <v-divider/>

            <img
                class="pa-6"
                src="../assets/ibeacon-map.jpg"/>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'IBeaconMapView',

    model: {
        prop: 'visible'
    },

    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        dialog: {
            get () {
                return this.visible
            },

            set (value) {
                this.$emit('input', value)
            }
        }
    },

    methods: {
        open () {
            this.dialog = true
        },

        close () {
            this.dialog = false
        }
    }
}
</script>

<style lang="scss" scoped>
.v-card {
    img {
        width: 100%;
    }
}
</style>
